var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"donate-container"},[_c('iframe',{staticStyle:{"max-width":"500px","min-width":"250px","max-height":"none !important"},attrs:{"src":"https://donorbox.org/embed/greatcommissionnow-org-1?default_interval=m","name":"donorbox","allowpaymentrequest":"","seamless":"seamless","frameborder":"0","scrolling":"no","height":"700px","width":"100%"}})])
}]

export { render, staticRenderFns }